// web/src/screens/login.ts — UI-01.
//
// Full-screen blue-sky-mountains background (content/images/_static/blue-sky-mountains.png;
// sourced by Janis). Falls back to --surface color if the image is missing.
//
// Single password input + "Iet iekšā!" CTA. Wrong-password error rendered
// below input in --danger color.

import { animateMini as animate } from "motion";
import { login } from "../api/login.js";
import { navigate } from "../main.js";

export function mount(root: HTMLElement, _props?: unknown): () => void {
  document.body.classList.add("theme-vocab"); // default theme on login

  root.innerHTML = `
    <section class="screen-login" style="background-image: url('/storage/images/_static/blue-sky-mountains.png'); background-size: cover; background-position: center; min-height: 100dvh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: var(--space-2xl); padding: var(--space-lg);">
      <h1 class="login-title" style="font-family: var(--font-fancy); font-size: var(--type-display); font-weight: 400; line-height: 1.1; margin: 0; text-align: center; letter-spacing: 0.02em; color: var(--text-on-color); text-shadow: 0 2px 12px rgba(0,0,0,0.45);">
        Runasprieks
      </h1>
      <form class="login-form" style="opacity: 0; background: rgba(255,255,255,0.6); padding: var(--space-2xl); border-radius: 16px; min-width: 320px; backdrop-filter: blur(8px);">
        <input
          type="password"
          name="password"
          placeholder="Parole"
          autocomplete="current-password"
          required
          style="display: block; width: 100%; min-height: 64px; padding: 0 var(--space-md); margin-bottom: var(--space-md); border: 2px solid var(--theme-color); border-radius: 8px; font-size: var(--type-heading); box-sizing: border-box;"
        >
        <button
          type="submit"
          style="display: block; width: 100%; min-height: 64px; background: var(--theme-color); color: var(--text-on-color); border: 0; border-radius: 8px; font-family: var(--font-fancy); font-size: 48px; font-weight: 400; line-height: 1; letter-spacing: 0.02em; cursor: pointer;"
        >Iet iekšā!</button>
        <p
          class="login-error"
          role="alert"
          style="display: none; color: var(--danger); margin-top: var(--space-md); margin-bottom: 0; font-size: var(--type-body);"
        ></p>
      </form>
    </section>
  `;

  const form = root.querySelector("form")!;
  const errEl = root.querySelector(".login-error") as HTMLElement;

  void animate(".login-form", { opacity: [0, 1] }, { duration: 0.6, ease: "easeOut" });

  async function onSubmit(e: SubmitEvent) {
    e.preventDefault();
    errEl.style.display = "none";
    const fd = new FormData(form);
    const pw = String(fd.get("password") ?? "");
    try {
      await login({ password: pw });
      navigate("/picker");
    } catch {
      errEl.textContent = "Parole nav pareiza. Pamēģini vēlreiz.";
      errEl.style.display = "block";
    }
  }

  form.addEventListener("submit", onSubmit);

  return () => {
    form.removeEventListener("submit", onSubmit);
  };
}
